/**
 * Entidade de Domínio: FunnelStage
 * Representa uma etapa do funil de vendas com suas regras de negócio
 */

import { ValidationError } from '../../core/errors/DomainErrors';

export class FunnelStage {
    constructor(
        public readonly id: string,
        public name: string,
        public conversionEvent: string,
        public readonly createdAt: Date = new Date(),
        public funnelId?: string,
        public order: number = 0,
        public deadline?: number,
        public color?: string | null
    ) {
        this.validate();
    }

    private validate(): void {
        if (!this.id || this.id.trim() === '') {
            throw new ValidationError('ID do estágio é obrigatório');
        }

        if (!this.name || this.name.trim() === '') {
            throw new ValidationError('Nome do estágio é obrigatório');
        }

        if (this.name.length < 2) {
            throw new ValidationError('Nome do estágio deve ter pelo menos 2 caracteres', 'name');
        }

        if (this.name.length > 50) {
            throw new ValidationError('Nome do estágio deve ter no máximo 50 caracteres', 'name');
        }
    }

    /**
     * Atualiza o nome do estágio
     */
    updateName(newName: string): void {
        if (!newName || newName.trim() === '') {
            throw new ValidationError('Nome do estágio é obrigatório');
        }

        if (newName.length < 2) {
            throw new ValidationError('Nome do estágio deve ter pelo menos 2 caracteres', 'name');
        }

        if (newName.length > 50) {
            throw new ValidationError('Nome do estágio deve ter no máximo 50 caracteres', 'name');
        }

        this.name = newName;
    }

    /**
     * Atualiza o evento de conversão
     */
    updateConversionEvent(event: string): void {
        this.conversionEvent = event;
    }

    /**
     * Atualiza a ordem do estágio
     */
    updateOrder(order: number): void {
        this.order = order;
    }

    /**
     * Atualiza o prazo (dias)
     */
    updateDeadline(deadline?: number): void {
        this.deadline = deadline;
    }

    /**
     * Getters
     */
    getName(): string {
        return this.name;
    }

    getConversionEvent(): string {
        return this.conversionEvent;
    }
}
